import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [{
	path: '',
	component: () => import('@/views/layout.vue'),
	children: [
	{
			path: '/',
			name: 'home',
			component: () => import('@/views/home/index.vue')
	},
	{
			path: '/product',
			name: 'product',
			component: () => import('@/views/product/product.vue'),
    },
    {
			path: '/case',
			name: 'case',
			component: () => import('@/views/successCase/case.vue'),
    },
    {
			path: '/service',
			name: 'service',
			component: () => import('@/views/service/service.vue'),
    },
    {
			path: '/about',
			name: 'about',
			component: () => import('@/views/about/about.vue'),
    },
    {
			path: '/joinus',
			name: 'joinus',
			component: () => import('@/views/joinUs/joinUs.vue'),
	}
	]
}]
const router = new VueRouter({
	  mode: 'history',
	//   base: process.env.BASE_URL,
	routes
})
export default router
